"use client";
import React, {useState} from "react";
import {useRouter} from "next/navigation";
import PropTypes from "prop-types";
import {SUPAPOWAR_COOKIE} from "@/lib/api";

const SecretSwitch = ({children, inline, initialSecretMode}) => {
  const router = useRouter();
  const [secretMode, setSecretMode] = useState(initialSecretMode);
  const switchSecretMode = () => {
    const next = !secretMode;
    // eslint-disable-next-line no-magic-numbers
    const expires = new Date(Date.now() + 90 * 24 * 60 * 60 * 1000).toUTCString();
    document.cookie = `${SUPAPOWAR_COOKIE}=${next}; expires=${expires}; path=/; samesite=strict; secure`;
    setSecretMode(next);
    router.refresh();
  };
  const elemClass = secretMode ? "secret" : "";

  if (inline) {
    return (
      <span className={elemClass} onClick={switchSecretMode}>
        {children}
      </span>
    );
  }
  return (
    <div className={elemClass} onClick={switchSecretMode}>
      {children}
    </div>
  );
};

SecretSwitch.propTypes = {
  children: PropTypes.any,
  inline: PropTypes.bool,
  initialSecretMode: PropTypes.bool,
};

export default SecretSwitch;
